import authHeader from "../../../authentication/authservices/auth-header";

import apiClient from "../../../http-common";

export const saveEMRTemplate = (obj) => {
  return apiClient.post(`/templateMaster/save`, obj, {
    headers: authHeader(),
  });
};

export const emrTemplateList = (id) => {
  return apiClient.get(`/templateMaster/emrTemplateList/${id}`, {
    headers: authHeader(),
  });
};

export const emrTemplateInfoDetails = (id) => {
  return apiClient.get(`/templateMaster/emrTemplateDetails/${id}`, {
    headers: authHeader(),
  });
};

export const emrTemplateEditData = (id) => {
  return apiClient.get(`/templateMaster/${id}`, {
    headers: authHeader(),
  });
};

export const updateEMRTemplate = (obj) => {
  return apiClient.put(`/templateMaster/update`, obj, {
    headers: authHeader(),
  });
};

export const getAdviceDropDownData = () => {
  return apiClient.get("/templateMaster/advices", {
    headers: authHeader(),
  });
};

export const deleteEMRTemplate = (id) => {
  return apiClient.delete(`/templateMaster/delete/${id}`, {
    headers: authHeader(),
  });
};

export const getPastHistoryAutoSearch = (desc) => {
  return apiClient.get(`/templateMaster/pastHistory/${desc}`, {
    headers: authHeader(),
  });
};

export const getCommonPastHistoryList = (doctorId) => {
  return apiClient.get(`/templateMaster/commonPastHistory/${doctorId}`, {
    headers: authHeader(),
  });
};

export const getTemplateSuggetion = (postObj) => {
  return apiClient.post(`/templateMaster/getEmrFieldTemplates`, postObj, {
    headers: authHeader(),
  });
};

export const saveTemplateMaster = (postObj) => {
  return apiClient.post(`/templateMaster/saveEmrFieldTemplate`, postObj, {
    headers: authHeader(),
  });
};
